/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-05 10:31:27
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginPagination from 'bee-pagination';
//require('bee-pagination/build/Pagination.css');
import hotkeys from './hotkeys';

import { Pagination as OriginPagination } from "@tinper/next-ui";
import { getLangCode } from '@platform/api';

require('./index.less');

let locale = {
    simpchn: 'zh-cn',
    english: 'en-us',
    tradchn: 'zh-tw',
};
let localeLang = getLangCode() || 'simpchn';

//越南语：vi-vn

// @hotkeys 和 @hetkeys()是不一样的
@hotkeys(true, { prevPage: 'ctrl+left', nextPage: 'ctrl+right' })
class Pagination extends Component {
    render() {
        let {
            gap = true,
            className,
            showQuickJumper = true,
            showJump,
            onChange,
            onSelect,
            onPageSizeChange,
            onDataNumSelect,
            pageSizeOptions,
            dataNumSelect,
            dataNum,
            pageSize,
            current,
            activePage,
            defaultActivePage,
            defaultCurrent,
            maxPageSize = 5000,
            total = 0,
            ...others
        } = this.props;
        showQuickJumper = showJump || showQuickJumper;
        onChange = onSelect || onChange;
        onPageSizeChange = onDataNumSelect || onPageSizeChange;
        pageSizeOptions = dataNumSelect || pageSizeOptions;
        pageSize = dataNum || pageSize;
        current = activePage || current;
        defaultCurrent = defaultActivePage || defaultCurrent;
        // 共享服务>作业平台>我的作业>我的作业 会有些问题 所以className采用覆盖法
        return <OriginPagination
            defaultCurrent={defaultCurrent}
            current={current}
            onChange={onChange}
            onPageSizeChange={onPageSizeChange}
            pageSizeOptions={pageSizeOptions}
            pageSize={pageSize}
            gap={gap}
            showQuickJumper={showQuickJumper}
            ref={obj => (this.pagination = obj)}
            pageSizeInput={{ max: maxPageSize }}
            locale={locale[localeLang]}
            total={total}
            {...others}
            className={`${className || 'PaginationStyle'} nc-pagination`} />;
    }
}
export default Pagination;
